// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"styles_pageNotFound__xzoyn","jsonWrapper":"styles_jsonWrapper__cNKkK","button":"styles_button__0En5V"};